import React from 'react';

import { PostViewOptions } from '../../../../constants/constants';

import { Post } from '../../../../types/Post';
import { PostItem } from './PostItem/PostItem';

interface PostListProps {
  posts: Post[];
  onViewChange: (viewName: PostViewOptions, viewCatchId?: string) => void;
  showDisplayEntity?: boolean;
}

export const PostList = ({
  posts,
  onViewChange: handleViewChange,
  showDisplayEntity,
}: PostListProps) => {
  return (
    <ul className="bg-lake-fog gap-y-4">
      {posts.map(post => (
        <li id={post._id} key={post._id} className="bg-sea-foam">
          <PostItem
            onViewChange={handleViewChange}
            post={post}
            showDisplayEntity={showDisplayEntity}
          />
        </li>
      ))}
    </ul>
  );
};
